import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import UploadErrorBanner from '../../pages/CitizenshipReimbursement/UploadDocument/ViewDetails/UploadErrorBanner';

const OfflineBanner: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(typeof navigator === 'undefined' ? true : navigator.onLine);

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const header = document.querySelector('header') || document.querySelector('[role=banner]');
    const footer = document.querySelector('footer') || document.querySelector('[role=contentinfo]');

    // container inserted after the header (so header remains visible)
    const container = document.createElement('div');
    container.dataset.offlineBanner = '1';

    header?.parentNode?.insertBefore(container, header.nextSibling);
    if (!header?.parentNode) footer?.parentNode?.insertBefore(container, footer);
    if (!header?.parentNode && !footer?.parentNode) document.body.insertBefore(container, document.body.firstChild);

    const onOnline = () => { 
      setIsOnline(true);
      // Show main content when online
      const mainContent = document.querySelector('main') || document.querySelector('[role=main]');
      if (mainContent) mainContent.style.display = '';
    };
    const onOffline = () => { 
      setIsOnline(false);
      // Hide main content when offline
      const mainContent = document.querySelector('main') || document.querySelector('[role=main]');
      if (mainContent) mainContent.style.display = 'none';
    };

    globalThis.addEventListener('online', onOnline);
    globalThis.addEventListener('offline', onOffline);

    if (typeof navigator !== 'undefined' && !navigator.onLine) onOffline();

    return () => {
      globalThis.removeEventListener('online', onOnline);
      globalThis.removeEventListener('offline', onOffline);
      container.remove();
      // Restore main content on cleanup
      const mainContent = document.querySelector('main') || document.querySelector('[role=main]');
      if (mainContent) mainContent.style.display = '';
    };
  }, []);

  if (isOnline) return null;

  const content = (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="max-w-[900px] w-full mx-auto">
        <UploadErrorBanner
          header="You are offline"
          message={"The application is not connected to the internet. Please check your network connection and try again."}
          className="mx-auto"
        />
      </div>
    </div>
  );

  const host = typeof document === 'undefined' ? null : document.querySelector('div[data-offline-banner="1"]');
  if (host) return ReactDOM.createPortal(content, host);

  return content;
};

export default OfflineBanner;
